export const SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST = 'SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST'
export const SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS = 'SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS'
export const SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE = 'SELECT_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE'

export const DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST = 'DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_REQUEST'
export const DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS = 'DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_SUCCESS'
export const DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE = 'DETAIL_MCU_PROJECT_CONFIGURATION_BMI_CRITERIA_FAILURE'

export const DETAIL_PARTNER_GENERAL_CONFIG_REQUEST = 'DETAIL_PARTNER_GENERAL_CONFIG_REQUEST'
export const DETAIL_PARTNER_GENERAL_CONFIG_SUCCESS = 'DETAIL_PARTNER_GENERAL_CONFIG_SUCCESS'
export const DETAIL_PARTNER_GENERAL_CONFIG_FAILURE = 'DETAIL_PARTNER_GENERAL_CONFIG_FAILURE'
